import React, { useMemo } from 'react';
import { Grid, Paper, Card, CardContent, Typography, Divider } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import moment from 'moment';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
import { useTable } from 'react-table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material/styles';

const StyledTableCell = withStyles(() => ({
    head: {
        backgroundColor: 'Silver',
        color: useTheme().palette.common.black,
        fontSize: 13,
        fontStyle: 'bold'
    },
    body: {
        fontSize: 13,
    },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: useTheme().palette.action.hover,
        },
    },
}))(TableRow);

const TripLog = ({ reportData }) => {
    const dimentions = useSelector(liveTrackinglayoutSelector);

    const tableData = useMemo(() => {
        if (reportData.reportRecords && reportData.reportRecords.length > 0) {
            return reportData.reportRecords.map(item => {
                const tripStart = item.tripStartDate || item.tripDate || item.tripStartTime || item.startTime;
                const tripEnd = item.tripEndDate || item.tripEndTime || item.endTime;
                return {
                    tripStartDate: tripStart ? moment(tripStart).format('D-MMM YY hh:mm A') : '',
                    vehicle: item.assetName || item.vehicle,
                    routeName: item.routeName || item.route,
                    routeLength: item.routeLength !== undefined && item.routeLength !== null
                        ? `${item.routeLength}`
                        : '',
                    truckRunDistance: item.truckRunDistance !== undefined && item.truckRunDistance !== null
                        ? `${item.truckRunDistance}`
                        : '',
                    tripStage: item.tripStage || item.tripStatus,
                    tripEndDate: tripEnd ? moment(tripEnd).format('D-MMM YY hh:mm A') : '',
                    fuelConsumption: item.fuelConsumption !== undefined && item.fuelConsumption !== null
                        ? `${item.fuelConsumption}`
                        : '',
                    fuelEfficiency: item.fuelEfficiency !== undefined && item.fuelEfficiency !== null
                        ? `${item.fuelEfficiency}`
                        : '',
                };
            });
        }
        return [];
    }, [reportData]);

    const tableColumns = useMemo(() => {
        return [
            { Header: 'Trip Start Date', accessor: 'tripStartDate' },
            { Header: 'Vehicle', accessor: 'vehicle' },
            { Header: 'Route Name', accessor: 'routeName' },
            { Header: 'Route Length (KM)', accessor: 'routeLength' },
            { Header: 'Truck Run Distance', accessor: 'truckRunDistance' },
            { Header: 'Trip Status', accessor: 'tripStage' },
            { Header: 'Trip End Date', accessor: 'tripEndDate' },
            { Header: 'Fuel Consumption', accessor: 'fuelConsumption' },
            { Header: 'Fuel Efficiency', accessor: 'fuelEfficiency' },
        ];
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns: tableColumns, data: tableData });

    if (reportData && reportData.reportRecords && reportData.reportRecords.length > 0) {
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px' }}>
                    <Grid container spacing={1}>
                        <Grid item container sm={12}>
                            <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" style={{ color: 'RoyalBlue' }}><b>Report Summary</b></Typography>
                                    <Divider />
                                    <br />
                                    <Grid container>
                                        <Grid item sm={2}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                From
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={10}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                {reportData.reqBody?.timeFrom ? `${moment(reportData.reqBody.timeFrom).format('Do MMM YY hh:mm A')}` : '-'}
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                To
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={10}>
                                            <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                {reportData.reqBody?.timeTo ? `${moment(reportData.reqBody.timeTo).format('Do MMM YY hh:mm A')}` : '-'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item sm={12} container>
                            <TableContainer component={Paper}>
                                <Table  {...getTableProps()}>
                                    <TableHead>
                                        {headerGroups.map(headerGroup => (
                                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <StyledTableCell
                                                        {...column.getHeaderProps()}
                                                    >
                                                        <b>{column.render('Header')}</b>
                                                    </StyledTableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableHead>
                                    <TableBody {...getTableBodyProps()}>
                                        {rows.map((row) => {
                                            prepareRow(row);
                                            return (
                                                <StyledTableRow {...row.getRowProps()}>
                                                    {row.cells.map(cell => {
                                                        return (
                                                            <StyledTableCell
                                                                {...cell.getCellProps()}
                                                            >
                                                                {cell.render('Cell')}
                                                            </StyledTableCell>
                                                        );
                                                    })}
                                                </StyledTableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        );
    }
    return null;
};

export default TripLog;
